module.exports = __webpack_public_path__ + "823ca4e3b75766f40c98e3826ed977a5.png";